<script>
    import { Pie } from 'vue-chartjs'

    export default {
        extends: Pie,
        props: {
            chartdata: Array,
            options: Array,
            dataname: Array,
            color: Array,

        },
        mounted () {


            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        data: this.options,
                        backgroundColor: this.color,
                    }
                ]
            }, {
                responsive: true,
                maintainAspectRatio: false,
                pieceLabel: {
                    mode: 'percentage',

                },
                legend: {
                    labels: {
                        boxWidth: 50,
                        fontSize: 24,
                    }
                },
            })
        }
    }
</script>

<style scoped>

</style>
